import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Lock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Hoteles */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Nuestros Hoteles</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <span className="text-white font-medium">Hotel Ciutat Martorell</span>
                <p className="text-gray-500">📍 Barcelona · 📞 +34 93 774 51 60</p>
              </li>
              <li>
                <span className="text-white font-medium">Port Sitges Hotel</span>
                <p className="text-gray-500">📍 Sitges · 📞 +34 93 811 31 77</p>
              </li>
              <li>
                <span className="text-white font-medium">Hostal San Francisco</span>
                <p className="text-gray-500">📍 Granja de Torrehermosa · 📞 +34 924 895 045</p>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contacto</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-blue-400" />
                <span>reservas@hotel-martorell.es</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-blue-400" />
                <span>+34 658 785 334</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-blue-400 mt-1" />
                <span>Av. de la Industria 16<br />Tres Cantos, Madrid</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <Link to="/aviso-legal" className="hover:text-white transition-colors">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="hover:text-white transition-colors">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-white transition-colors">
                  Política de Cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-gray-500 text-sm">
            <Link
              to="/login"
              className="inline-flex items-center bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full shadow-sm font-medium transition-all"
              data-testid="admin-access-btn"
            >
              <Lock className="h-4 w-4 mr-2" />
              Administración
            </Link>
            <div className="text-center md:text-right">
              <p>© 2026 Eye Star S.L. Todos los derechos reservados.</p>
              <p className="mt-1">CIF: B87171740</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
